(() => {
  const cfg = window.__FK_TELEMETRY__ || {};
  if (!cfg.enabled) return;

  const base = () => ({
    ts: new Date().toISOString(),
    path: location.pathname,
    pageType: document.body?.className || '',
    viewport: `${window.innerWidth}x${window.innerHeight}`
  });

  const emit = (type, payload = {}) => {
    const event = { ...base(), type, ...payload };
    window.dispatchEvent(new CustomEvent('fk:telemetry', { detail: event }));
    if (cfg.debug) console.info('[FK telemetry]', event);
    if (!cfg.endpoint) return;
    try {
      const body = JSON.stringify(event);
      if (navigator.sendBeacon) navigator.sendBeacon(cfg.endpoint, new Blob([body], { type: 'application/json' }));
      else fetch(cfg.endpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true, credentials: 'omit' }).catch(() => {});
    } catch (_) {}
  };

  window.FKTelemetry = { emit };
  window.addEventListener('error', (e) => emit('js_error', { message: String(e.message || 'Erro JavaScript').slice(0, 240), source: e.filename ? new URL(e.filename, location.href).pathname : '' }));
  window.addEventListener('unhandledrejection', (e) => emit('unhandled_rejection', { message: String(e.reason?.message || e.reason || 'Promise rejeitada').slice(0, 240) }));

  let cls = 0;
  try {
    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) if (!entry.hadRecentInput) cls += entry.value;
    }).observe({ type: 'layout-shift', buffered: true });
    new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const last = entries[entries.length - 1];
      if (last) emit('web_vital', { metric: 'LCP', value: Math.round(last.startTime) });
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (_) {}
  addEventListener('pagehide', () => emit('web_vital', { metric: 'CLS', value: Number(cls.toFixed(4)) }));
  emit('page_view');
})();
